import { Component, Input, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Filter } from '../../../business-entities/Filter';
import { PagerData } from '../../../business-entities/PagerData';
import { CustomerService } from '../../../business-services/customer.service';
import { PaginationService } from '../../../services/pagination.service';
import { ViewCustomerComponent } from '../../customer/view-customer/view-customer.component';

@Component({
  selector: 'app-customer-validation',
  templateUrl: './customer-validation.component.html',
  styleUrls: ['./customer-validation.component.css'],
})
export class CustomerValidationComponent implements OnInit {
  customer: any;
  searchTerm: string;
  isWidgetData: string;
  isFromEditAppointment:boolean;
  filter: Filter = new Filter();
  filterItems: any[];
  isSelectActive = false;
  pagerData: PagerData = {
    page: 1,
    pagerSize: Constant.GridPagerSize,
  };
  activePanel = ['first', 'second'];
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  totalCount: number = 0;
  customerList = [];
  @Input() customerDetails: any;
  @Input() fromWidget: any;
  @Input() preferredDealerId: any;
  popupCloseResult = false;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly modalService: NgbModal,
    private readonly spinner: NgxSpinnerService,
    private readonly clipboardApi: ClipboardService,
    private readonly pagerService: PaginationService,
    private readonly service: CustomerService,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.customer = this.customerDetails;
    if(this.customer?.cust_ContactNo != null){
      this.customer.cust_ContactNo.internationalNumber = this.customer?.cust_ContactNo?.internationalNumber.replace(/\s/g, '');
    }
    this.isWidgetData = this.fromWidget ? 'lblAsPerWidget' : 'lblAsPerDF';
    this.searchTerm = this.customer?.mobileNo?.replace(/\s/g, '');
    this.onSearchFilter();
  }

  onSearchFilter() {
    this.service.customerListRequest.startRecordNumber = 0;
    this.service.customerListRequest.searchTerm = this.searchTerm;
    this.getCustomerList();
  }

  async getCustomerList() {
    this.spinner.show();
    await this.service
      .getCustomerList(this.service.customerListRequest)
      .then((response) => {
        this.spinner.hide();
        this.customerList = this.customerDataMapper(
          response.responseObject.customerList
        );
        if (response.responseObject?.result?.errorCode == '5449') {
          this.totalCount = 0;
        } else {
          this.totalCount = response.responseObject.customerList[0].totalCount;
        }
        this.resetPagerData(
          this.supplierInitiliseGridFromServer(
            this.customerList,
            this.totalCount
          )
        );
        if (this.pagerData.page > 1) {
          this.resetPagerData(
            this.initilisePagerFromServer(
              this.pagerData.page,
              this.pagerData.pagerSize,
              this.totalCount
            )
          );
        }
      },_error => {
        this.spinner.hide();
      });
  }

  private customerDataMapper(customer: any) {
    let supperArray = [];
    if (customer && customer.length > 0) {
      for (let index = 0; index < customer.length; index++) {
        const element = customer[index];

        let single = Object();
        single.rowNumber =
          this.service.customerListRequest.startRecordNumber + 1 + index;
        single.id = element.id;
        single.isSelected = false;
        single.customerId = element.customerId;
        single.customerName = element.customerName;
        single.firstName = element.firstName;
        single.lastName = element.lastName;
        single.address =
          element.addressLine1 +
          (element.addressLine2
            ? ', ' + element.addressLine2
            : element.addressLine2);
        single.city = element.city;
        single.country = element.country;
        single.email = element.email;
        single.mobileNo = element.mobileNo;
        if(element.mobileCode[0]=='+')
          single.mobileCode = element.mobileCode
        else
          single.mobileCode = "+"+element.mobileCode
        single.isActive = element.isActive;
        single.customerNo = element.customerNo;
        single.pincode = element.pincode;
        single.customerType = element.customerType
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems; // .slice(this.pager.startIndex, this.pager.endIndex + 1);
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  onCreate() {
    const modalref = this.modalService.open(ViewCustomerComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.customerDetails = this.customer;
    modalref.componentInstance.isFromServiceAdvisor = true;
    modalref.componentInstance.preferredDealerId = this.preferredDealerId;
    modalref.result.then(
      (_response) => {
        this.ngOnInit();
      }
    );
  }

  async setPage(pagerData: PagerData) {
    if (
      pagerData == null ||
      pagerData === undefined ||
      pagerData.page < 1 ||
      pagerData.page > this.pager.totalPages
    ) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
    this.service.customerListRequest.startRecordNumber =
      pagerData.pagerSize * (pagerData.page - 1);
    this.service.customerListRequest.pageSize = pagerData.pagerSize;
    await this.getCustomerList();
  }

  onCustomerSelect(customerIndex: number,event) {
    this.customerList.forEach((item, index) => {
      if (index == customerIndex) {
        if(item.isActive)
        {
          item.isSelected = true;
          this.isSelectActive = true;
        }
        else
        {
          item.isSelected = false;
          this.isSelectActive = false;
          
          let modelHeadermsg = this.translate.instant("lblInactiveCustomer");
          let modelBody = this.translate.instant("lblCustomerInactiveSelectionMsgWAR");
            const modalRef = this.modalService.open(NgInfoModalContent);
            modalRef.componentInstance.modelHeader = modelHeadermsg;
            modalRef.componentInstance.modelBody = modelBody;
            modalRef.result.then((_result) => { 
              // This is intentional
            }, (reason) => {           
              this.popupCloseResult = this.getDismissDeleteReason(reason);
            });
        }
        
      } else {
        item.isSelected = false;
      }
    });
  }

  onSelect() {
    let cust = this.customerList.filter((customer) => customer.isSelected);
    this.activeModal.close({ success: true, customer: cust[0] });
  }

  copyText(value: any) {
    this.clipboardApi.copyFromContent(value);
  }

  //Close popUp
  OnClose() {
    this.activeModal.close({ success: false});
    this.isSelectActive = false;
  }

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
}
